import { Boxes, Images, Layers, PenLine, Settings2, Tag, Truck, type LucideIcon } from 'lucide-react';
import { FormSection } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import type { ReactNode } from 'react';
import { sectionElementId, type EditorSection } from './sections.ts';

export const SECTION_ICONS: Readonly<Record<EditorSection, LucideIcon>> = {
  essentials: PenLine,
  media: Images,
  pricing: Tag,
  variants: Layers,
  stock: Boxes,
  shipping: Truck,
  more: Settings2,
};

export const EditorSectionCard = ({ section, children }: { section: EditorSection; children: ReactNode }) => {
  const { t } = useTranslation();
  const Icon = SECTION_ICONS[section];
  return (
    <FormSection
      id={sectionElementId(section)}
      title={t(`productEditor.${section}`)}
      description={t(`productEditor.${section}Hint`)}
      icon={<Icon size={18} />}
    >
      {children}
    </FormSection>
  );
};
